export default "/static/explore/86f255d8923c60e93c55378a783a789bb15b2d64/_next/static/images/logo-square-5bb1ec821602baf22bd8996504d378c7.png";